import { Input } from '@/components/ui/input'
import { FilterDropdown } from '@/components/ui/filter-dropdown'
import {
  portalActivityLabels,
  type PortalActivityListData,
  type PortalActivityListKind,
} from './portalActivityLists.types'
export function PortalActivityControls({
  kind,
  params,
  change,
  data,
}: {
  kind: PortalActivityListKind
  params: URLSearchParams
  change: (key: string, value: string) => void
  data?: PortalActivityListData
}) {
  const key = kind === 'courses' ? 'status' : 'level'
  const options =
    kind === 'courses'
      ? [
          { value: 'completed', label: 'Completed' },
          { value: 'in_progress', label: 'In progress' },
        ]
      : (data?.levels ?? []).map((level) => ({ value: level, label: level }))
  const label = kind === 'courses' ? 'Status' : 'Level'
  return (
    <div className="flex flex-wrap items-center gap-2 pt-2">
      <Input
        aria-label={portalActivityLabels[kind].search}
        placeholder={portalActivityLabels[kind].search}
        className="h-9 w-56"
        value={params.get('q') ?? ''}
        onChange={(event) => change('q', event.target.value)}
      />
      <FilterDropdown
        label={label}
        emptyLabel={label}
        options={options}
        selected={new Set((params.get(key) ?? '').split(',').filter(Boolean))}
        onChange={(values) => change(key, [...values].join(','))}
      />
    </div>
  )
}
